const puck = require("@fae/source/assets/images/ember-tactics/overworlds/00 General Overworld/overworldmaps-locationpuck.png")

export default {
    "1": {
        "images": [
            require("@fae/source/assets/images/ember-tactics/overworlds/01 Woods Overworld/overworldmaps-woods-3-base.png"),
            require("@fae/source/assets/images/ember-tactics/overworlds/01 Woods Overworld/overworldmaps-woods-2-beacon-DIM.png"),
            // require("@fae/source/assets/images/ember-tactics/overworlds/01 Woods Overworld/overworldmaps-woods-2-beacon-LIT.png"),
            // require("@fae/source/assets/images/ember-tactics/overworlds/01 Woods Overworld/overworldmaps-woods-1-fog-tier3.png"),
            // require("@fae/source/assets/images/ember-tactics/overworlds/01 Woods Overworld/overworldmaps-woods-1-fog-tier2.png"),
            // require("@fae/source/assets/images/ember-tactics/overworlds/01 Woods Overworld/overworldmaps-woods-1-fog-tier1.png"),
            require("@fae/source/assets/images/ember-tactics/overworlds/01 Woods Overworld/overworldmaps-woods-0-eyes.png"),
            require("@fae/source/assets/images/ember-tactics/overworlds/01 Woods Overworld/overworldmaps-woods-examplepath.png"),
            {"url": require("@fae/source/assets/images/ember-tactics/overworlds/00 General Overworld/papertexture-screensize.png"), "blendmode": "overlay", "opacity": 0.2},
            {"url": require("@fae/source/assets/images/ember-tactics/overworlds/00 General Overworld/overworldmaps-frame.png"), "size": "contain"},
        ],
        "locations": {
            // "ch1-0": {
            //     "key": "ch1-0",
            //     "chapterKey": "1-0",
            //     "position": {"x": 1, "y": 1},
            //     "isDisplayed": true,
            //     "isReachable": false,
            //     "text": "ch1-0",
            // },
            "ch1-1": {
                "key": "ch1-1",
                "chapterKey": "1-1",
                "position": {"x": 1.9, "y": 7},
                "isDisplayed": true,
                "isReachable": true,
                // "text": "ch1-1",
                "puck": puck,
            },
            "ch1-2": {
                "key": "ch1-2",
                "chapterKey": "1-2",
                "position": {"x": 4.55, "y": 5.45},
                "isDisplayed": true,
                "isReachable": true,
                // "text": "ch1-2",
                "puck": puck,
            },
            "ch1-3": {
                "key": "ch1-3",
                "chapterKey": "1-3",
                "position": {"x": 6.2, "y": 3.3},
                "isDisplayed": true,
                "isReachable": true,
                // "text": "ch1-3",
                "puck": puck,
            },
            "ch1-4": {
                "key": "ch1-4",
                "chapterKey": "1-4",
                "position": {"x": 9.25, "y": 4.1},
                "isDisplayed": true,
                "isReachable": true,
                // "text": "ch1-4",
                "puck": puck,
            },
            "ch1-5": {
                "key": "ch1-5",
                "chapterKey": "1-5",
                "position": {"x": 11.9, "y": 2.6},
                "isDisplayed": true,
                "isReachable": false,
                // "text": "ch1-5",
                "puck": puck,
            },
        }
    },
    "2": {
        "images": [
            require("@fae/source/assets/images/ember-tactics/overworlds/02 Cliffs Overworld/overworldmaps-cliffs-3-base.png"),
            require("@fae/source/assets/images/ember-tactics/overworlds/02 Cliffs Overworld/overworldmaps-cliffs-2-beacon-DIM.png"),
            // require("@fae/source/assets/images/ember-tactics/overworlds/02 Cliffs Overworld/overworldmaps-cliffs-2-beacon-LIT.png"),
            // require("@fae/source/assets/images/ember-tactics/overworlds/02 Cliffs Overworld/overworldmaps-cliffs-1-fog-tier3.png"),
            // require("@fae/source/assets/images/ember-tactics/overworlds/02 Cliffs Overworld/overworldmaps-cliffs-1-fog-tier2.png"),
            require("@fae/source/assets/images/ember-tactics/overworlds/02 Cliffs Overworld/overworldmaps-cliffs-1-fog-tier1.png"),
            require("@fae/source/assets/images/ember-tactics/overworlds/02 Cliffs Overworld/overworldmaps-cliffs-examplepath.png"),
            {"url": require("@fae/source/assets/images/ember-tactics/overworlds/00 General Overworld/papertexture-screensize.png"), "blendmode": "overlay", "opacity": 0.2},
            {"url": require("@fae/source/assets/images/ember-tactics/overworlds/00 General Overworld/overworldmaps-frame.png"), "size": "contain"},
        ],
        "locations": {
            "ch2-1": {
                "key": "ch2-1",
                "chapterKey": "2-1",
                "position": {"x": 4.45, "y": 2.3},
                "isDisplayed": true,
                "isReachable": true,
                // "text": "ch2-1",
                "puck": puck,
            },
            "ch2-2": {
                "key": "ch2-2",
                "chapterKey": "2-2",
                "position": {"x": 2.2, "y": 4},
                "isDisplayed": true,
                "isReachable": true,
                // "text": "ch2-2",
                "puck": puck,
            },
            "ch2-3": {
                "key": "ch2-3",
                "chapterKey": "2-3",
                "position": {"x": 4.4, "y": 5.7},
                "isDisplayed": true,
                "isReachable": true,
                // "text": "ch2-3",
                "puck": puck,
            },
            "ch2-4": {
                "key": "ch2-4",
                "chapterKey": "2-4",
                "position": {"x": 9.2, "y": 7},
                "isDisplayed": true,
                "isReachable": true,
                // "text": "ch2-4",
                "puck": puck,
            },
            "ch2-5": {
                "key": "ch2-5",
                "chapterKey": "2-5",
                "position": {"x": 12, "y": 4.5},
                "isDisplayed": true,
                "isReachable": true,
                // "text": "ch2-5",
                "puck": puck,
            },
            "ch2-6": {
                "key": "ch2-6",
                "chapterKey": "2-6",
                "position": {"x": 8.7, "y": 3.1},
                "isDisplayed": true,
                "isReachable": true,
                // "text": "ch2-5",
                "puck": puck,
            },
        }
    },
    "3": {
        "images": [
            require("@fae/source/assets/images/ember-tactics/overworlds/03 Swamp Overworld/overworldmaps-swamp-3-base.png"),
            // require("@fae/source/assets/images/ember-tactics/overworlds/03 Swamp Overworld/overworldmaps-swamp-2-beacon-LIT.png"),
            require("@fae/source/assets/images/ember-tactics/overworlds/03 Swamp Overworld/overworldmaps-swamp-2-beacon-DIM.png"),
            // require("@fae/source/assets/images/ember-tactics/overworlds/03 Swamp Overworld/overworldmaps-swamp-1-fog-tier3.png"),
            require("@fae/source/assets/images/ember-tactics/overworlds/03 Swamp Overworld/overworldmaps-swamp-1-fog-tier2.png"),
            require("@fae/source/assets/images/ember-tactics/overworlds/03 Swamp Overworld/overworldmaps-swamp-1-fog-tier1.png"),
            require("@fae/source/assets/images/ember-tactics/overworlds/03 Swamp Overworld/overworldmaps-swamp-examplepath.png"),
            {"url": require("@fae/source/assets/images/ember-tactics/overworlds/00 General Overworld/papertexture-screensize.png"), "blendmode": "overlay", "opacity": 0.2},
            {"url": require("@fae/source/assets/images/ember-tactics/overworlds/00 General Overworld/overworldmaps-frame.png"), "size": "contain"},
        ],
        "locations": {
            "ch3-1": {
                "key": "ch3-1",
                "chapterKey": "3-1",
                "position": {"x": 11.55, "y": 6.9},
                "isDisplayed": true,
                "isReachable": true,
                // "text": "ch3-1",
                "puck": puck,
            },
            "ch3-2": {
                "key": "ch3-2",
                "chapterKey": "3-2",
                "position": {"x": 3.5, "y": 7.1},
                "isDisplayed": true,
                "isReachable": false,
                // "text": "ch3-2",
                "puck": puck,
            },
            "ch3-3": {
                "key": "ch3-3",
                "chapterKey": "3-3",
                "position": {"x": 8.75, "y": 5.2},
                "isDisplayed": true,
                "isReachable": true,
                // "text": "ch3-3",
                "puck": puck,
            },
            "ch3-4": {
                "key": "ch3-4",
                "chapterKey": "3-4",
                "position": {"x": 9.3, "y": 3.3},
                "isDisplayed": true,
                "isReachable": false,
                // "text": "ch3-4",
                "puck": puck,
            },
            "ch3-5": {
                "key": "ch3-5",
                "chapterKey": "3-5",
                "position": {"x": 6.15, "y": 2.75},
                "isDisplayed": true,
                "isReachable": false,
                // "text": "ch3-4",
                "puck": puck,
            },
            "ch3-x": {
                "key": "ch3-5",
                "chapterKey": "3-5",
                "position": {"x": 2.25, "y": 2.75},
                "isDisplayed": true,
                "isReachable": false,
                // "text": "ch3-5",
                "puck": puck,
            },
        }
    },
    "4": {
        "images": [
            require("@fae/source/assets/images/ember-tactics/overworlds/04 Ashlands Overworld/overworldmaps-ashlands-3-base.png"),
            require("@fae/source/assets/images/ember-tactics/overworlds/04 Ashlands Overworld/overworldmaps-ashlands-2-beacon-DIM.png"),
            require("@fae/source/assets/images/ember-tactics/overworlds/04 Ashlands Overworld/overworldmaps-ashlands-1-fog-tier3.png"),
            require("@fae/source/assets/images/ember-tactics/overworlds/04 Ashlands Overworld/overworldmaps-ashlands-1-fog-tier2.png"),
            require("@fae/source/assets/images/ember-tactics/overworlds/04 Ashlands Overworld/overworldmaps-ashlands-1-fog-tier1.png"),
            require("@fae/source/assets/images/ember-tactics/overworlds/04 Ashlands Overworld/overworldmaps-ashlands-0-eyes.png"),
            require("@fae/source/assets/images/ember-tactics/overworlds/04 Ashlands Overworld/overworldmaps-ashlands-examplepath.png"),
            {"url": require("@fae/source/assets/images/ember-tactics/overworlds/00 General Overworld/papertexture-screensize.png"), "blendmode": "overlay", "opacity": 0.2},
            {"url": require("@fae/source/assets/images/ember-tactics/overworlds/00 General Overworld/overworldmaps-frame.png"), "size": "contain"},
        ],
        "locations": {
            "ch4-1": {
                "key": "ch4-1",
                "chapterKey": "4-1",
                "position": {"x": 4.6, "y": 7.5},
                "isDisplayed": true,
                "isReachable": false,
                // "text": "ch4-1",
                "puck": puck,
            },
            "ch4-2": {
                "key": "ch4-2",
                "chapterKey": "4-2",
                "position": {"x": 10.6, "y": 5.6},
                "isDisplayed": true,
                "isReachable": false,
                // "text": "ch4-2",
                "puck": puck,
            },
            "ch4-3": {
                "key": "ch4-3",
                "chapterKey": "4-3",
                "position": {"x": 6.4, "y": 4.4},
                "isDisplayed": true,
                "isReachable": false,
                // "text": "ch4-3",
                "puck": puck,
            },
            "ch4-4": {
                "key": "ch4-4",
                "chapterKey": "4-4",
                "position": {"x": 3.3, "y": 3.7},
                "isDisplayed": true,
                "isReachable": false,
                // "text": "ch4-4",
                "puck": puck,
            },
            "ch4-5": {
                "key": "ch4-5",
                "chapterKey": "4-5",
                "position": {"x": 7.8, "y": 3.2},
                "isDisplayed": true,
                "isReachable": false,
                // "text": "ch4-5",
                "puck": puck,
            },
            "ch4-6": {
                "key": "ch4-6",
                "chapterKey": "4-6",
                "position": {"x": 9, "y": 2.15},
                "isDisplayed": true,
                "isReachable": false,
                // "text": "ch4-5",
                "puck": puck,
            },
        }
    },
    "5": {
        "images": [
            {"url": require("@fae/source/assets/images/ember-tactics/overworlds/05 Mountain Overworld/overworldmaps-mountain-3-base.png"), "position": "center"},
            {"url": require("@fae/source/assets/images/ember-tactics/overworlds/05 Mountain Overworld/overworldmaps-mountain-1-fog-tier1.png"), "position": "center"},
            {"url": require("@fae/source/assets/images/ember-tactics/overworlds/05 Mountain Overworld/overworldmaps-mountain-examplepath.png"), "position": "center"},
            {"url": require("@fae/source/assets/images/ember-tactics/overworlds/00 General Overworld/papertexture-screensize.png"), "blendmode": "overlay", "opacity": 0.2},
            {"url": require("@fae/source/assets/images/ember-tactics/overworlds/00 General Overworld/overworldmaps-frame.png"), "size": "contain"},
        ],
        "locations": {
            "ch5-1": {
                "key": "ch5-1",
                "chapterKey": "5-1",
                "position": {"x": 13, "y": 1},
                "isDisplayed": true,
                "isReachable": false,
                // "text": "ch5-1",
                "puck": puck,
            },
            "ch5-2": {
                "key": "ch5-2",
                "chapterKey": "5-2",
                "position": {"x": 4.55, "y": 5.85},
                "isDisplayed": true,
                "isReachable": false,
                // "text": "ch5-2",
                "puck": puck,
            },
            "ch5-3": {
                "key": "ch5-3",
                "chapterKey": "5-3",
                "position": {"x": 7.6, "y": 1.6},
                "isDisplayed": true,
                "isReachable": false,
                // "text": "ch5-3",
                "puck": puck,
            },
        }
    }
}
